import { GridColumn, EditableGridFieldTypes, Alignment } from '../../components/sib-forms/grid/grid.config';
import { DateUtil } from '../../helpers/date.util';
import * as utils from '../../helpers/utils';
import * as mapUtils from '../../helpers/map.utils';
import { CurrencyHelperPipe } from '../../shared/helpers/currency.pipe/currencyHelperPipe';
import { MountImageStatus } from '../../shared/constants/mount-image-status-enum';

export const MountingReportColumns: Array<GridColumn> = [
  {
    field: 'srNo',
    name: 'srNo',
    header: 'Sr ',
    required: true,
    width: '2.7vw',  // changed from 3vw to 2.7vw --> Raveena
    editable: false,
    hidden: false,
    default: true,
    permanent: true,
    sortable: false,
    styleClass: 'sr-number',
    type: EditableGridFieldTypes.CUSTOM
  },
  {
    field: 'customId',
    name: 'HID',
    header: 'HID',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    width: '8vw',
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    }
  },
  {
    field: 'district',
    name: 'district',
    header: 'District',
    required: true,
    editable: false,
    hidden: false,
    permanent: false,
    width: '7vw',
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
  },
  {
    field: 'city',
    name: 'city',
    header: 'City',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    width: '7vw',
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    }
  },
  {
    field: 'areaName',
    name: 'area',
    header: 'Area',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    width: '7vw',
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
    /* displayFn: (data) => {
      if (data.area) {
        return data.area.name;
      } else {
        return '-';
      }
    } */
  },
  {
    field: 'location',
    name: 'location',
    header: 'Location',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    width: '20vw',
    default: true,
    sortable: true,
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search',
      custom: false
    },
  },
  {
    field: 'size',
    name: 'size',
    header: 'Size',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
    displayFn: (data) => {
      if (data.size) {
        return data.size;
      } else {
        return '-';
      }
    }
  },
  {
    field: 'employeeName',
    name: 'employeeName',
    header: 'Employee',
    required: true,
    editable: false,
    sortable: true,
    permanent: false,
    default: true,
    width: '7vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
    displayFn: (data) => {
      if (data) {
        return data.employeeName;
      } else {
        return '-';
      }
    }
  },
  {
    field: 'mountingItems.mounter.fullName',
    name: 'mounter',
    header: 'Mounter',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    width: '10vw',
    default: true,
    sortable: true,
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'in',
      placeHolder: 'Search',
      custom: true
    },
    displayFn: (data) => {
      if (data && data.mountingItems && data.mountingItems.mounter && data.mountingItems.mounter.firstName) {
        return data.mountingItems.mounter.firstName + ' ' + data.mountingItems.mounter.lastName;
      } else {
        return '-';
      }
    }
  },
  {
    field: 'displayName',
    name: 'campaign',
    header: 'Display Name',
    required: true,
    editable: false,
    sortable: false,
    hidden: false,
    permanent: true,
    width: '9vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
    displayFn: (data) => {
      if (data) {
        return data.displayName;
      } else {
        return '-';
      }
    }
  },
  {
    field: 'itemStartDate',
    name: 'itemStartDate',
    header: 'Item St. Dt.',
    required: true,
    editable: false,
    sortable: true,
    width: '7vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    displayFn: (data) => {
      if (data) {
        return DateUtil.dategridFormatter(data.itemStartDate);
      } else {
        return '-';
      }
    },
  },
  {
    field: 'itemEndDate',
    name: 'itemEndDate',
    header: 'Item End Dt.',
    required: true,
    editable: false,
    sortable: true,
    width: '7vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    displayFn: (data) => {
      if (data) {
        return DateUtil.dategridFormatter(data.itemEndDate);
      } else {
        return '-';
      }
    },
  },
  {
    field: 'mountingItems.creativeName',
    name: 'creativeName',
    header: 'Creative Name',
    required: true,
    editable: false,
    sortable: true,
    width: '9vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'contains',
      placeHolder: 'Search'
    },
    displayFn: (data) => {
      if (data.mountingItems && data.mountingItems.creativeName !== 'Default') {
        return data.mountingItems.creativeName
      } else {
        return '-';
      }
    },
  },
  {
    field: 'mountingItems.date',
    name: 'mountingDate',
    header: 'Mt. Date',
    required: true,
    editable: false,
    sortable: true,
    hidden: false,
    permanent: true,
    width: '7vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    displayFn: (data) => {
      if (data.mountingItems) {
        return DateUtil.dategridFormatter(data.mountingItems.date)
      } else {
        return '-';
      }
    },
  },
  {
    field: 'mountingItems.imageStatus',
    name: 'imageStatus',
    header: 'Status',
    required: true,
    editable: false,
    hidden: false,
    permanent: true,
    sortable: true,
    width: '10vw',
    styleClass: 'word-break-wrap',
    type: EditableGridFieldTypes.TEXT,
    filter: {
      matchMode: 'in',
      placeHolder: 'Search',
      custom: true
    },
    displayFn: (data) => {
      if (data && data.mountingItems && data.mountingItems.imageStatus) {
        return MountImageStatus[data.mountingItems.imageStatus];
      } else {
        return '-';
      }
    },
  },
];

export const MountingReportMap = (() => {
  return mapUtils.createMap(MountingReportColumns);
})();
